export const radioUrl = 'https://radio.tspigot.net/radio/radio.mp3'
export const apiUrl = 'https://radio.tspigot.net/api'

